import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import cn from "classnames";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { NavLink, UncontrolledTooltip } from "reactstrap";
import { useGlobalCore } from "../../../cores/globals";
import { Icon } from "../companies/icons/Icon";

interface Props {
  isOpen?: boolean;
  children: ReactNode;
  label: string;
  iconName?: IconName;
  iconPrefix?: IconPrefix;
  activeUrls?: string[];
  disabled?: boolean;
  disabledMessage?: string;
}

export const NavItemGroup = (props: Props) => {
  const {
    isOpen,
    children,
    label,
    iconName,
    iconPrefix,
    activeUrls = [],
    disabled,
    disabledMessage,
  } = props;
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { collapseSideBar } = useGlobalCore();

  useEffect(() => {
    isOpen && setOpen(isOpen);
  }, [isOpen]);

  const toggle = useCallback(() => {
    !disabled && setOpen(!open);
  }, [disabled, open]);

  const isActive = useCallback(() => activeUrls.indexOf(pathname) >= 0, [
    activeUrls,
    pathname,
  ]);
  useEffect(() => setOpen(isActive()), [isActive, pathname]);

  return (
    <div
      id={label.replace(/\s/g, "")}
      className={cn("pointer mb-2 sidebar-item", {
        "active-group": isActive(),
      })}
    >
      <NavLink
        onClick={toggle}
        className={cn({ 
          disabled,
          "text-center": collapseSideBar
        })}
      >
        {iconName && (
          <Icon
            className="group-icon"
            name={iconName}
            prefix={iconPrefix}
          />
        )}
        {!collapseSideBar && <span className="ml-3 group-label">{label}</span>}
      </NavLink>
      {open && <div className="pl-3">{children}</div>}
      {disabledMessage && disabled && (
        <UncontrolledTooltip
          placement="right"
          target={label.replace(/\s/g, "")}
        >
          {disabledMessage}
        </UncontrolledTooltip>
      )}
    </div>
  );
};
